import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-download-sales-excel",
  template: `<std-modal
    [show]="true"
    cardClass="!max-w-[90vw] min-w-[300px]"
    headerClass="bg-primary"
    [closeOnOutside]="false"
    (close)="autoDestory()"
    *transloco="let t"
  >
    <div header class="text-tertiary text-title">Scarica excel vendite</div>
    <div content class="text-secondary text-medium">
      <div>
        L'excel che sarà scaricato utilizzera i filtri attualmente selezionati
      </div>
      <div class="w-[50%] mt-4 mx-auto">
        <std-button
          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
          class="w-full"
          (click)="downloadExcel(t)"
          >Scarica</std-button
        >
      </div>
    </div>
  </std-modal>`,
  styles: [],
  standalone: false,
})
export class DownloadSalesExcelComponent implements OnInit {
  @Input() fatherElement = {};
  @Input() fatherContaierRef: any;

  constructor(
    private host: ElementRef<HTMLElement>,
    private loader: LoaderService,
    private rest: RestService,
    private message: Message,
    private httpClient: HttpClient
  ) {}

  baseUrl = api.baseUrl;

  ngOnInit(): void {}

  downloadExcel(t: any) {
    this.loader.on();
    let options = {
      filters: [
        ...this.fatherContaierRef.filtersList,
        ...this.fatherContaierRef.baseFiltersList,
      ],
    };

    this.httpClient
      .get(
        this.baseUrl +
          `/booking/summary/view/export?options=${JSON.stringify(options)}`,
        {
          headers: {
            Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
              "token"
            )}`,
          },
          responseType: "blob",
        }
      )
      .subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.loader.off(true);
      });
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
